import { ApiError } from '@shared/api-client/index';
import { toast, toastApiError } from '@shared/ui/toast/toast-store';
import i18n from 'i18next';

/** The api's shaped code when adding a seat exceeds the free allowance. */
export const SEAT_LIMIT_REACHED = 'SEAT_LIMIT_REACHED';

/** True when a failed request is the seat-cap block (free plan, no room). */
export function isSeatLimitError(error: unknown): boolean {
	return error instanceof ApiError && error.code === SEAT_LIMIT_REACHED;
}

/**
 * Seat-cap failures (invite / enable over the free allowance) get a dedicated
 * upgrade toast pointing at Billing; every other failure falls through to the
 * generic error toast. Used outside the React tree (React Query `onError`), so
 * it reads copy off the shared i18n instance rather than a hook.
 */
export function toastSeatLimitOrApiError(error: unknown): void {
	if (isSeatLimitError(error)) {
		toast({
			variant: 'error',
			title: i18n.t('members.seatLimit.toast.title', 'Upgrade to add more members'),
			description: i18n.t(
				'members.seatLimit.toast.body',
				'Your free plan includes one seat. Upgrade on the Billing page to add teammates.',
			),
		});
		return;
	}
	toastApiError(error);
}
